import React, { useEffect, useState, useRef, useCallback } from "react";
import "./MasterSetting.css";
import axios from "axios";
import useAuthStore from "../../services/authStore";
import { toastError, toastSuccess } from "../../services/toaster";
import { FaSpinner } from "react-icons/fa";

export default function AllowDays() {
  const token = useAuthStore((state) => state.token);
  const companyId = useAuthStore((state) => state.companyId);

  const API_URL = process.env.REACT_APP_API_URL;

  const hasFetched = useRef(false);

  const [loading, setLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);

  const [allowDays, setAllowDays] = useState("");
  const [existingData, setExistingData] = useState(null);

  // ================= FETCH API (FIXED WITH useCallback) =================
  const fetchAllowDays = useCallback(async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_URL}/allowdays/${companyId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data) {
        setExistingData(res.data);
        setAllowDays(res.data.allowdays || "");
      } else {
        setExistingData(null);
        setAllowDays("");
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        setExistingData(null);
        setAllowDays("");
      } else {
        toastError("Failed to fetch Allow Days");
      }
    } finally {
      setLoading(false);
    }
  }, [API_URL, companyId, token]);

  // ================= INITIAL LOAD =================
  useEffect(() => {
    if (companyId && !hasFetched.current) {
      hasFetched.current = true;
      fetchAllowDays();
    }
  }, [companyId, fetchAllowDays]);

  // ================= CANCEL =================
  const handleCancel = () => {
    if (existingData) {
      setAllowDays(existingData.allowdays);
    } else {
      setAllowDays("");
    }
  };

  // ================= SAVE =================
  const handleSave = async () => {
    if (allowDays === "") {
      toastError("Please enter Allow Days");
      return;
    }

    try {
      setSaveLoading(true);

      const payload = {
        company_id: companyId,
        allowdays: Number(allowDays),
      };

      if (existingData) {
        await axios.put(`${API_URL}/allowdays/${companyId}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toastSuccess("Allow Days Updated");
      } else {
        await axios.post(`${API_URL}/allowdays/${companyId}`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toastSuccess("Allow Days Created");
      }

      await fetchAllowDays();
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        "Failed to save Allow Days";

      toastError(message);
    } finally {
      setSaveLoading(false);
    }
  };

  // ================= LOADING UI =================
  if (loading) {
    return (
      <div className="allowdays-container">
        <div className="center-loader">
          <FaSpinner className="spinner" />
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  // ================= UI =================
  return (
    <div className="allowdays-container">
      <div className="expense-form-page">
        <div className="form-content">
          <div className="form-header">
            <h3>Allow Days</h3>
          </div>

          <div className="scroll-inner-body">
            <div className="row">
              <div className="col-md-4">
                <div className="formgroup">
                  <label>
                    Allow Days <span style={{ color: "red" }}>*</span>
                  </label>

                  <input
                    type="number"
                    min="0"
                    placeholder="Enter Allow Days"
                    value={allowDays}
                    onChange={(e) => setAllowDays(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button className="cancel-btn" onClick={handleCancel}>
              Cancel
            </button>

            <button
              className="save-btn"
              onClick={handleSave}
              disabled={saveLoading}
            >
              {saveLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
